import constants from '~/config/constants';
import { SET_CURRENT_TIMESTAMP } from '~/store/mutationTypes';

/**
 * @param {import('vuex').Store<any>} store
 * @param {import('vue-router/types/router').Dictionary<string | (string | null)[]>} query
 * @return {OfferWeb.Scheduler}
 */
const scheduleFactory = function(store, query) {
    return function(start, end) {
        let currentTime = Math.floor(Date.now() / 1000);

        if (!constants.IS_PRODUCTION) {
            if (query.timestamp && typeof query.timestamp === 'string') {
                currentTime = Number.parseInt(query.timestamp);
            }
        }

        if (!start || currentTime < start || (end && currentTime >= end)) {
            return false;
        }
        store.commit(SET_CURRENT_TIMESTAMP, currentTime);
        return true;
    };
};

/** @type {import('@nuxt/types').Plugin} */
const plugin = ({ app, store, query, error }, inject) => {
    inject('schedule', scheduleFactory(store, query));

    app.$schedulePage = ({ start, end } = {}) => {
        const showPage = app.$schedule(start, end);

        if (!showPage) {
            return error({
                statusCode: 404,
            });
        }
    };
};

export default plugin;
